<script setup>
const { $on, $emit } = useNuxtApp()
const type = ref("confirmDialog") // prompt
$on("confirmDialog", confirmDialog)

$on("promptDialog", promptDialog)
$on("alertDialog", alertDialog)

let msg = ref("")
let title = ref("")
let bannerInfo = ref("")
let visible = ref(false)
const userInput = ref("")
const name = ref("")

function confirmDialog(ev) {
  type.value = "confirmDialog"
  msg.value = ev.msg
  title.value = ev.title || "Confirm"
  bannerInfo=ev.bannerInfo
  visible.value = true
}
function alertDialog(ev) {
  type.value = "alertDialog"
  msg.value = ev.msg
  title.value = ev.title || "Alert"
  visible.value = true
}

function promptDialog(ev) {
  type.value = "promptDialog"
  msg.value = ev.msg
  title.value = ev.title
  name.value = ev.name
  visible.value = true
}

function result(value) {
  visible.value = false
  if (type.value === "confirmDialog") {
    $emit("confirmDialog:result", value)
  } else if (type.value === "alertDialog") {
    $emit("alertDialog:result", value)
  } else {
    $emit("promptDialog:result", value && userInput.value)
    userInput.value = ""
  }
}
</script>
<template>
  <v-dialog v-model="visible" width="400px">
    <CoreCard
      v-if="type === 'alertDialog'"
      color="warning"
      icon="$warning"
      :title="title"
      @confirm="result(true)"
      :show-cancel="false"
    >
      <div v-html="msg" />
    </CoreCard>
    <CoreCard
      v-else
      color="warning"
      icon="$warning"
      :title="title"
      @confirm="result(true)"
      @cancel="result(false)"
      show-cancel
    >
      <div v-html="msg" />
      <v-alert
        v-if="bannerInfo"
        density="compact"
        :text="bannerInfo"
        type="warning"
        class="v-messages__message v-messages"
        :icon="false"
      ></v-alert>
      <v-textarea v-if="type === 'promptDialog'" :label="name" v-model="userInput" />
      <template v-if="type === 'promptDialog'" v-slot:actions>
        <v-btn
          color="warning"
          @click="result(false)"
          icon="mdi-close"
          class="confirm-btn-cancel"
        ></v-btn>
        <v-btn
          :disabled="!userInput.length"
          color="success"
          @click="result(userInput)"
          text
          label
          icon="mdi-check"
          class="confirm-btn-ok"
        ></v-btn>
      </template>
    </CoreCard>
    <!-- <v-btn class='mr-1' @click='result(false)' color='error'>Cancel</v-btn>
        <v-btn @click='result(true)' color='success'>Ok</v-btn> -->
  </v-dialog>
</template>
